import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  fetchConnectionProfilesAsync,
  selectConnectionProfilesData,
  selectConnectionProfilesError,
} from "data";
import { TableComponent } from "components";
import Container from "components/global/Container";
import { AddButton } from "components/TableComponent/components";
import {
  selectConnectionProfilesSort,
  updateSort,
} from "data/features/connectionProfiles/connectionProfileSlice";
import { useTranslation } from "react-i18next";
import { connectionProfileColumns } from "../helpers";

const ConnectionProfilesHeading = ({ handleAdd }) => {
  const { t } = useTranslation();
  return (
    <AddButton
      aria-label="AddConnectionProfileButton"
      onClick={() => handleAdd("/connection-profiles/add")}
    >
      {t("connectionProfiles.heading")}
    </AddButton>
  );
};

ConnectionProfilesHeading.propTypes = {
  handleAdd: PropTypes.func.isRequired,
};

export function ConnectionProfiles() {
  const dispatch = useDispatch();
  const data = useSelector(selectConnectionProfilesData);
  const error = useSelector(selectConnectionProfilesError);
  const selectSort = useSelector(selectConnectionProfilesSort);

  const handleUpdateSort = (sort) => {
    dispatch(updateSort(sort));
  };
  const handleFetchConnectionProfiles = useCallback(
    (params) => dispatch(fetchConnectionProfilesAsync(params)),
    []
  );

  useEffect(() => {
    handleFetchConnectionProfiles({ sort: selectSort });
  }, [dispatch]);

  const columns = useMemo(() => connectionProfileColumns, []);

  return (
    <>
      {error && JSON.stringify(error)}
      {data && (
        <Container small>
          <TableComponent
            fetchData={handleFetchConnectionProfiles}
            columns={columns}
            data={data.objects}
            totalItems={data.total_elements}
            renderHeading={ConnectionProfilesHeading}
            sortObject={selectSort}
            updateSortObject={handleUpdateSort}
          />
        </Container>
      )}
    </>
  );
}
